<template>
  <div>
    <c-upload
      v-model="data"
      :limit="limit"
      :size="uploadSize"
      :disabled="disabled"
      :loading.sync="componentLoading"
    />
  </div>
</template>

<script>
import CUpload from '@/components/upload/index.vue'

export default {
  components: {
    CUpload,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: undefined,
      limit: this.option.uploadLimit || this.option.numberMax || 9,
      uploadSize: this.option.size || '',
      componentLoading: false,
    }
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    loading: {
      deep: true,
      handler(e) {
        this.componentLoading = e
        this.$emit('update:loading', e)
      },
    },
    componentLoading: {
      deep: true,
      handler(e) {
        this.$emit('update:loading', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
    'option.numberMax': {
      handler(e) {
        if (e) {
          this.limit = e
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.dark-layout {
  .ant-upload {
    border-color: $theme-dark-input-border-color;
    background-color: $theme-dark-input-bg;
  }
}
</style>
